import React, { FC, useLayoutEffect, useState } from 'react';
import {
  useGetConsumerBalanceQuery,
  useLazyGetAllConsumerOperationByIdQuery,
  useLazyGetConsumerIntegrationsQuery,
} from '../consumer.service';
import { Consumer, ConsumerBilling } from '../consumer.types';
import ConsumerInfo from '../ConsumerInfo';
import ConsumerTabsPanel from '../ConsumerTabsPanel';
import cls from './ConsumerCard.module.scss';
import ConsumerCardSubInfo from '../ConsumerCardSubInfo';

type ConsumerCardProps = {
  consumer: Consumer;
  consumerId: string;
};

const ConsumerCard: FC<ConsumerCardProps> = ({ consumer, consumerId }) => {
  const [operationsPage, setOperationsPage] = useState<number>(0);
  const [integrationsPage, setIntegrationsPage] = useState<number>(0);
  const [scrollOperationsList, setScrollOperationsList] = useState<ConsumerBilling[]>([]);
  const size = 10;
  const [operationTrigger, { data: consumerBillingList, isLoading: consumerBillingListLoading }] =
    useLazyGetAllConsumerOperationByIdQuery();
  const [
    integrationsTrigger,
    { data: consumerIntegrationsList, isLoading: consumerIntegrationsLoading },
  ] = useLazyGetConsumerIntegrationsQuery();
  const resetHandler = () => {
    setOperationsPage(0);
    setScrollOperationsList([]);
  };
  const [balance, setBalance] = useState<string>('0');
  const isB2B = consumer.consumerType === 'CONSUMER_B2B';
  const { data: consumerBalance } = useGetConsumerBalanceQuery(consumerId, { skip: !isB2B });
  const selectedHandler = (value: string | null) => {
    if (value === 'integrations') {
      integrationsTrigger({
        consumerId: consumerId as string,
        page: integrationsPage,
        size: 10,
      });
    } else if (value === 'operations') {
      setOperationsPage(0);
      setScrollOperationsList([]);
      operationTrigger({
        id: consumerId as string,
        page: operationsPage,
        size,
      });
    }
  };
  useLayoutEffect(() => {
    if (!isB2B) return;
    operationTrigger({
      id: consumerId as string,
      page: operationsPage,
      size,
    });
  }, [operationTrigger, consumerId, operationsPage, isB2B]);
  useLayoutEffect(() => {
    if (consumerBalance && consumerBalance.amount > 0) {
      setBalance((consumerBalance.amount / 100).toFixed(2));
    } else {
      setBalance('0');
    }
  }, [consumerBalance]);
  return (
    <div className={cls.Container}>
      <ConsumerInfo consumer={consumer} />
      <ConsumerCardSubInfo consumer={consumer} balance={balance} resetHandler={resetHandler} />
      <ConsumerTabsPanel
        consumerId={consumerId}
        consumerBillingList={consumerBillingList}
        consumerBillingListLoading={consumerBillingListLoading}
        consumerIntegrationsList={consumerIntegrationsList}
        consumerIntegrationsLoading={consumerIntegrationsLoading}
        selectedHandler={selectedHandler}
        scrollOperationsList={scrollOperationsList}
        setIntegrationsPage={setIntegrationsPage}
        setOperationsPage={setOperationsPage}
        setScrollOperationsList={setScrollOperationsList}
        integrationsPage={integrationsPage}
        operationsPage={operationsPage}
        isB2B={isB2B}
      />
    </div>
  );
};

export default ConsumerCard;
